import { Routes } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';

export const pointofsalesroutes: Routes = [

  {
    path: 'shopsystem',
    loadChildren: () => import('./shopsystem/shopsystem.module').then(m => m.ShopSystemModule),
    data: { animation: 'shopsystem' },
    canActivate: [AuthGuard]
  },
  {
    path: 'priceposters',
    loadChildren: () => import('./priceposters/priceposters.module').then(m => m.PricePostersModule),
    data: { animation: 'priceposters' },
    canActivate: [AuthGuard]
  },
  {
    path: 'storeequipment',
    loadChildren: () => import('./storeequipment/storeequipment.module').then(m => m.StoreEquipmentModule),
    data: { animation: 'storeequipment' },
    canActivate: [AuthGuard]
  },
 
]
